import gql from 'graphql-tag';

export const GET_ADDRESS_BY_ZIP = gql`
  query($zip: String!) {
    location: addressByZip(zip: $zip) {
      prefecture
      city
    }
}`;

export const GET_PHOTOS = gql`
  query($id: Int!) {
    photos(appointmentId: $id) {
      id
      type
      description
      url
      file {
        originalFile {
          originalName
        }
      }
    }
  }
`;

export const GET_AI_PHOTOS = gql`
  query($appointmentId: Int!) {
    getAiPhotos:aiInspectionRelevantImages( filters: { appointmentId: $appointmentId }, pageSize: 100 ) {
      data {
        id
        imageId
        imageTag
        imageUrl
        originalImageUrl
        type
        isDamage
        partId
      }
    }
  }
`;

export const GET_SHAKENSHO_PDF = gql`
  query($appointmentId: Int!) {
    shakenshoPdf(appointmentId: $appointmentId) {
      url
      originalName
    }
  }`;

export const UPDATE_PHOTO = gql`
  mutation(
    $appointmentId: Int,
    $fileData: CpFileInput!,
    $type: String!,
    $description: String,
  ) {
  addPhoto(
    appointmentId: $appointmentId,
    fileData: $fileData,
    type: $type,
    description: $description
  )
}`;

export const DELETE_PHOTO = gql`
  mutation($id: Int!) {
    deleteCarPhoto(id: $id)
  }
`;

export const GET_BRANDS = gql`
  query {
    carBrands(pageSize: 500, sorting: "weight asc") {
      data {
        id
        name
        start
        end
      }
    }
  }
`;

export const GET_MODELS = gql`
  query($year: Int, $brandId: Int) {
    getModels(year: $year, brandId: $brandId) {
      id
      title
    }
  }
`;

export const GET_MODIFICATIONS = gql`
    query($modelId: Int!, $year: String) {
    carModifications(
        filters: {
          modelId: $modelId,
          customFilters: [
            {field: "start", operator: LE, value: $year},
            {field: "end", operator: GE, value: $year}
          ]
        },
        pageSize: 10000
    ) {
      data {
        id
        fullTitle
      }
    }
  }`;

export const APPOINTMENT_AND_OWNER_SUMMARY = gql`
  query($id: Int!) {
    appointment(id: $id) {
      id
      zip
      city
      time
      branch {
        id
        name
      }
      inspector {
        id
        lastName
        name
      }
      campaign
      car {
        id
        carBrand {
          id
          name
        }
        year
        modelId {
          id
          title
        }
        modificationId {
          id
          code
        }
        modificationExt
        mileageId
        colorId
        deliveryTime
        documentHandoverTime
      }
      carLoanToBePaidAmount
      notification
      customer {
        id
        lastName
        name
        phone
        email
        clientCabinetCustomer {
          id
          address
        }
      }
    }
  }`;

export const SEARCH_GRADE = gql`
  query(
    $brandText: String,
    $modelText: String,
    $gradeText: String,
    $typeText: String,
    $year: Int,
    $appointmentId: Int,
  ) {
    searchGradeBasedOnCarMasterGrade(
      brandText: $brandText,
      modelText: $modelText,
      gradeText: $gradeText,
      typeText: $typeText,
      year: $year,
      appointmentId: $appointmentId,
    ){
      data {
        id
        title
        fullTitle
        bodyTitle
        brandId
        brandName{
          name
        }
        modelId
        model{
          title
        }
        code
        catalogId
        start
        end
      }
    }
  }`;

export const SEARCH_APPOINTMENTS = gql`
  query searchAppointments($filters: CustomerInput) {
    customers(filters: $filters, sorting: "a.time desc", pageSize: 25) {
      data {
        id
        lastName
        name
        furiganaLastName
        furiganaName
        phone
        appointment {
          id
          selfInspectionFlag
          status
          substatus
          car {
            id
            brandId
            year
            title
          }
          clientCabinetWorkflow {
            id
            step
          }
          time
          campaign
          dateCreate
        }
      }
    }
  }
`;

export const BASIC_TAB = gql`
  query($id: Int!) {
    appointment(id: $id) {
      id
      car {
        id
        brandId
        modelId {
          id
          title
        }
        year
        modificationId {
          id
          code
        }
        modificationExt
        inspectionDate
        plate
        vin
        reimportVin
        numberPlate
        engineType
        sts
        seats
        engine
        carHistory
        recyclingDeposit
        serviceBook
        serviceWarranty
        recordBook
        insurance
        colorId
        colorOriginal
        colorChanged
        transmissionDrive
        speedometerChanges
        importOfficial
        climate
        climateDescription
        originalColorId
        transmission
        transmissionMovement
        transmissionMovementDescription
        timingBeltExchangeHistory
        timingBeltExchange
        timingBeltExchangeValue
        timingBeltExchangeValueType
        mileage
        speedometer
        isDefaultStsMonth
      }
    }
  }`;

export const GET_CAR_FIELDS = gql`
  query GetCarFields($carId: Int, $typeId: Int, $code: String, $id: Int) {
    carFields(filters: { carId: $carId, typeId: $typeId, code: $code, id: $id }, pageSize: 500) {
      data {
        carId
        code
        value
        id
      }
    }
  }`;

export const getCarWith = (params = []) => gql`
  query($id: Int!) {
    appointment(id: $id) {
      id
      selfInspectionFlag
      sentShuppinhyoFlag
      car {
        id
        ${params.join('\n')}
      }
      selfInspectionFlag
    }
  }`;

export const GET_REMAINING_FIELDS = gql`
  query($appointmentId: Int!, $tabs: [Tab]) {
    remainingFields(appointmentId: $appointmentId, tabs: $tabs) {
      tab
      count
      fields
    }
  }
`;
export const GET_SCORES = gql`
  query($carId: Int!) {
    score: getScore (carId: $carId) {
      scoreCondition
      scoreExterior
      scoreInterior
    }
  }`;

export const GET_USER_DATA = gql`
  {
    user: getUserData {
      id
      name
      email
      roles
    }
  }
`;

export const PRE_INSPECTION_FLAGS = gql`
  query getAppointmentFlags($id: Int!) {
    appointment(id: $id) {
      id
      meetingTookPlace
      selfInspectionFlag
      sentShuppinhyoFlag
    }
  }
`;

export const GET_AI_INSPECTION_STATUS = gql`
  query($appointmentId: Int!) {
    appointment(id: $appointmentId) {
      id
      aiInspectionStatus
      aiInspectionExpired
      aiInspectionErrorCode
    }
  }
`;

export const GET_AI_INSPECTION_URL = gql`
  query($appointmentId: Int!) {
    generateInspectionUrl(appointmentId: $appointmentId) {
      url
    }
  }
`;

export const GET_CAR_TITLE = gql`
  query($id: Int!) {
    appointment(id: $id) {
      id
      car {
        id
        brandId
        modificationExt
        modificationId {
          id
          title
        }
        modelId {
          id
          title
        }
      }
    }
  }`;

export const UPSERT_CAR_FIELD = gql`
  mutation(
    $carId: Int!
    $typeId: Int!
    $value: String!
    $code: String!
  ) {
    upsertCarField(
      data: {
        carId: $carId
        code: $code
        typeId: $typeId
        value: $value
      }
    )
  }`;

export const UPDATE_TYPE = type => gql`
  mutation(
      $field: String!
      $value: String
      $id: Int!
    ) {
    update${type}(
      field: $field
        value: $value
        id: $id
    ) {
    id
  }
}`;

export const UPDATE_CAR_PHOTO = UPDATE_TYPE('CarPhoto');

export const ON_UPDATE_APPOINTMENT = params => gql`
  {
    appointment {
      id
      ${params.field}
      __typename
    }
  }`;

export const ON_UPDATE_CAR = params => gql`
  {
    appointment {
      id
      ${params.field}
      __typename
    }
  }`;

export const GET_CAR_ID_AND_STEP_INFO = gql`
  query($id: Int!) {
    appointment(id: $id) {
      id
      selfInspectionFlag
      car {
        id
      }
      clientCabinetWorkflow {
        id
        step
      }
    }
  }`;



// WEBPACK FOOTER //
// ./src/queries.js